import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import styles from "./style.module.css";
import SEOHeading from '../../components/ui/SEOHeading';

function AboutSection() {
  return (
    <Container fluid className={`py-5 ${styles.container}`}>
      <Row className="justify-content-center">
        <Col lg={8} md={10}>
          {/* Header Section */}
          <div className={`${styles.header} mb-5`}>
            <SEOHeading level={1} className="h3 fw-bold mb-3">
              SimSim – Nömrələrinizi İdarə Etməyin Rəqəmsal Yolu
            </SEOHeading>
            <p className="lead text-muted">
              SimSim, nömrələrinizi idarə etmək üçün{" "}
              <span className="text-primary fw-bold">unikal və innovativ həll</span> təqdim edir
            </p>
          </div>

          {/* How It Works Section */}
          <section className={styles.section}>
            <div className={`${styles.bgGray} rounded p-4`}>
              <SEOHeading level={2} className={`h5 ${styles.subtitle} mb-3`}>Necə işləyir</SEOHeading>
              <ul className="list-unstyled ms-4">
                <li className="mb-2"><span className="text-primary me-2">•</span><strong>Excel</strong> faylına nömrələrinizi daxil edirsiniz</li>
                <li className="mb-2"><span className="text-primary me-2">•</span>Nömrələriniz <strong>internet üzərindən</strong> paylaşılır və saytımızda yayımlanır</li>
                <li className="mb-2"><span className="text-primary me-2">•</span>Təqdim etdiyimiz <strong>planşetlər</strong> vasitəsilə kağız kataloqlar tamamilə əvəz olunur</li>
              </ul>
            </div>
          </section>

          {/* Advantages Section */}
          <div className={`${styles.bgGray} rounded p-4`}>
            <SEOHeading level={2} className={`h5 ${styles.subtitle} mb-3`}>Üstünlüklər</SEOHeading>
            <ul className="list-unstyled ms-4">
              <li className="mb-2"><span className="text-primary me-2">•</span><strong>Kağız israfı</strong> və <strong>qaralama</strong> problemlərinə son</li>
              <li className="mb-2"><span className="text-primary me-2">•</span><strong>"15 nömrə limiti"</strong> kimi məhdudiyyətlər artıq <strong>yoxdur</strong></li>
              <li className="mb-2"><span className="text-primary me-2">•</span><strong>7/24</strong> istənilən cihazdan <strong>idarəetmə imkanı</strong></li>
              <li className="mb-2"><span className="text-primary me-2">•</span>İşçi heyətinin <strong>iş yükünü</strong> azaldır, müştərilər üçün isə <strong>rahatlıq yaradır</strong></li>
              <li className="mb-2"><span className="text-primary me-2">•</span>Müştərilər <strong>mağazaya gəlmədən</strong> nömrələri görüntüləyə bilər</li>
              <li className="mb-2"><span className="text-primary me-2">•</span><strong>QR kod</strong> ilə nömrələrinizi rahatlıqla paylaşın və əlçatan edin</li>
              <li className="mb-2"><span className="text-primary me-2">•</span>Nömrələriniz təkcə regionda deyil, <strong>dünyanın dörd bir tərəfində</strong> əlçatan olsun</li>
            </ul>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default AboutSection;
